module.exports = __webpack_public_path__ + "img/logo.bbad44f1.png";